/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Delivery_Board_Just_NowInputs */

const en_delivery_board_just_now = /** @type {(inputs: Delivery_Board_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just now`)
};

const es_delivery_board_just_now = /** @type {(inputs: Delivery_Board_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ahora mismo`)
};

const fr_delivery_board_just_now = /** @type {(inputs: Delivery_Board_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`À l'instant`)
};

const de_delivery_board_just_now = /** @type {(inputs: Delivery_Board_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerade eben`)
};

const id_delivery_board_just_now = /** @type {(inputs: Delivery_Board_Just_NowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Baru saja`)
};

/** @type {(inputs: Delivery_Board_Just_NowInputs) => LocalizedString} */
const ja_delivery_board_just_now = en_delivery_board_just_now;

/** @type {(inputs: Delivery_Board_Just_NowInputs) => LocalizedString} */
const zh_delivery_board_just_now = en_delivery_board_just_now;

/** @type {(inputs: Delivery_Board_Just_NowInputs) => LocalizedString} */
const ar_delivery_board_just_now = en_delivery_board_just_now;

/** @type {(inputs: Delivery_Board_Just_NowInputs) => LocalizedString} */
const it_delivery_board_just_now = en_delivery_board_just_now;

/** @type {(inputs: Delivery_Board_Just_NowInputs) => LocalizedString} */
const ru_delivery_board_just_now = en_delivery_board_just_now;

/** @type {(inputs: Delivery_Board_Just_NowInputs) => LocalizedString} */
const pt_delivery_board_just_now = en_delivery_board_just_now;

/** @type {(inputs: Delivery_Board_Just_NowInputs) => LocalizedString} */
const ko_delivery_board_just_now = en_delivery_board_just_now;

/**
* | output |
* | --- |
* | "Just now" |
*
* @param {Delivery_Board_Just_NowInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const delivery_board_just_now = /** @type {((inputs?: Delivery_Board_Just_NowInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Delivery_Board_Just_NowInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_delivery_board_just_now(inputs)
	if (locale === "es") return es_delivery_board_just_now(inputs)
	if (locale === "fr") return fr_delivery_board_just_now(inputs)
	if (locale === "de") return de_delivery_board_just_now(inputs)
	if (locale === "ja") return ja_delivery_board_just_now(inputs)
	if (locale === "zh") return zh_delivery_board_just_now(inputs)
	if (locale === "ar") return ar_delivery_board_just_now(inputs)
	if (locale === "id") return id_delivery_board_just_now(inputs)
	if (locale === "it") return it_delivery_board_just_now(inputs)
	if (locale === "ru") return ru_delivery_board_just_now(inputs)
	if (locale === "pt") return pt_delivery_board_just_now(inputs)
	return ko_delivery_board_just_now(inputs)
});